import React, { useState, useEffect } from 'react';
import { CircularProgress, Paper, useMediaQuery, FormControl, Select, MenuItem } from "@material-ui/core";
import config from './config.json';
import { customTheme } from "./customTheme";
//import { useNotify } from "react-admin";
import { Helmet } from "react-helmet";
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';


const ParkingMapView = () => {
    //const notify = useNotify()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let mapViewType = sessionStorage.getItem('mapview_type') ? sessionStorage.getItem('mapview_type') : null
    const [selectedOption, setSelectedOption] = useState(mapViewType ? mapViewType : "Society")
    const [parkingCoordinates, setParkingCoordinates] = useState([])
    const [loading, setLoading] = useState(false)

    // let lat = sessionStorage.getItem('user_latitude')
    // let long = sessionStorage.getItem('user_longitude')

    const handleChange = (event) => {
        setSelectedOption(event.target.value)
    };

    const getParkingCoordinates = () => {
        setLoading(true)
        const requestBody = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        };
        fetch(`${config.HOST_NAME}/crm/v3/parking/coordinates?type=${selectedOption}`, requestBody)
            .then(res => {
                saveTokens(res)
                return res.json()
            })
            .then((json) => {
                if (json.success) {
                    setLoading(false)
                    setParkingCoordinates(json.data)
                } else {
                    setLoading(false)
                    notify(json.message, "warning")
                }
            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
                notify("Something Went Wrong", "warning")
            })
    }

    useEffect(() => {
        getParkingCoordinates()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption])


    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 25px" : "0px 22px 25px 22px", boxShadow: isSmallDevice ? "none" : undefined, height: "calc(100vh + 450px)", marginTop: 10 }} >

            <Helmet>
                <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin="" />
            </Helmet>

            <p style={{ fontWeight: "600" }}>Parkings Map View</p>

            <FormControl variant="outlined" size="small">
                <Select
                    value={selectedOption}
                    onChange={handleChange}
                >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Society">Societies</MenuItem>
                    <MenuItem value="Commercial">Commercials</MenuItem>
                    <MenuItem value="Private">Private</MenuItem>
                    <MenuItem value="Government">Government</MenuItem>
                </Select>
            </FormControl>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "90%", marginTop: 20 }}>
                {loading &&
                    <div>
                        <CircularProgress />
                    </div>
                }

                {
                    !loading && parkingCoordinates.length !== 0 &&

                    <MapContainer center={[25.4358, 81.8463]} zoom={6} scrollWheelZoom={true} style={{ width: "100%", height: "100%" }}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {
                            parkingCoordinates.map((data) => {
                                return (
                                    <Marker position={[data.parking_latitude, data.parking_longitude]} style={{ color: "#18cc69" }}>
                                        <Tooltip><b>{data.name}</b></Tooltip>
                                    </Marker>
                                )
                            })
                        }

                    </MapContainer>
                }
            </div>


        </Paper>
    )

}
export default ParkingMapView